<template>
  <div class="block block-link-shadow text-center">
    <div class="block-content block-content-full block-sticky-options pt-30">
      <div class="block-options">

        <b-dropdown class="dropdown-no-btn" right>
          <template slot="button-content">
            <i class="fa fa-fw fa-ellipsis-v"></i>
          </template>
          <b-dropdown-item @click="syncProducts" :disabled="syncing" v-if="isImportChannel">
            <i class="fa fa-fw fa-tag mr-5"></i>Importeer Producten
          </b-dropdown-item>
          <b-dropdown-item @click="syncStocks" :disabled="syncing" v-if="isImportChannel && salesChannel.key.includes('vm')">
            <i class="fa fa-fw fa-tag mr-5"></i>Synchroniseer voorraad
          </b-dropdown-item>
          <b-dropdown-item @click="syncOrders" :disabled="syncing" v-if="isImportChannel">
            <i class="fa fa-fw fa-shopping-cart mr-5"></i>Importeer Bestellingen
          </b-dropdown-item>
          <b-dropdown-item @click="syncRefunds" :disabled="syncing" v-if="isImportChannel">
            <i class="fa fa-fw fa-shopping-cart mr-5"></i>Importeer Retours
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <img class="img-avatar" :src="'/static/img/sales-channels/' + salesChannel.type + '.png'" alt="">
    </div>

    <div class="block-content block-content-full block-content-sm bg-body-light">
      <div class="font-w600 mb-5">{{salesChannel.name}}</div>
      <div class="font-size-sm text-muted">{{salesChannel.type | type}}</div>
    </div>
    <div class="block-content">
      <div class="row items-push text-center">
        <div class="col-12" v-if="isImportChannel">
          <div v-if="syncing">
            <div class="mb-5"><i class="fa fa-refresh fa-spin fa-2x"></i></div>
            <div class="font-size-sm text-muted">Import starten...</div>
          </div>
          <div v-else>
            <div class="mb-5"><i class="si si-like fa-2x"></i></div>
            <div class="font-size-sm text-muted">Laatste import: {{salesChannel.date_last_synced | moment('calendar')}}</div>
          </div>
        </div>
        <div class="col-12" v-else>
          <div class="mb-5"><i class="si si-like fa-2x"></i></div>
          <div class="font-size-sm text-muted">Import n.v.t.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['salesChannel'],
  data () {
    return {
      syncing: false
    }
  },
  computed: {
    isImportChannel () {
      return this.salesChannel.type === 'woocommerce' || this.salesChannel.type === 'channable' || this.salesChannel.type === 'channelengine'
    }
  },
  methods: {
    syncProducts () {
      this.syncing = true

      this.$api.syncProducts(this.salesChannel.key)
        .then((response) => {
          this.$emit('sync')
          this.syncing = false
        })
        .catch(() => {
          this.syncing = false
          this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het importeren van de producten. Probeer het opnieuw.', 'error')
        })
    },
    syncOrders () {
      this.syncing = true
      this.$api.syncOrders(this.salesChannel.key)
        .then((response) => {
          this.$emit('sync')
          this.syncing = false
        })
        .catch(() => {
          this.syncing = false
          this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het importeren van de bestellingen. Probeer het opnieuw.', 'error')
        })
    },
    syncRefunds () {
      this.syncing = true
      this.$api.syncRefunds(this.salesChannel.key)
        .then((response) => {
          this.$emit('sync')
          this.syncing = false
        })
        .catch(() => {
          this.syncing = false
          this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het importeren van de bestellingen. Probeer het opnieuw.', 'error')
        })
    },
    syncStocks () {
      this.syncing = true
      this.$api.syncStocks(this.salesChannel.key)
        .then((response) => {
          this.$emit('sync')
          this.syncing = false
        })
        .catch(() => {
          this.syncing = false
          this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het sycen van de voorraad. Probeer het opnieuw.', 'error')
        })
    }
  },
  filters: {
    type (type) {
      switch (type) {
        case 'woocommerce': return 'Woocommerce Webshop'
        case 'physical': return 'Fysieke Winkel'
        case 'channelengine': return 'ChannelEngine Kanaal'
        case 'channable': return 'Channable Kanaal'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SalesChannelWidget.vue?5e722edf